import './utils/flexible'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import { Lazyload, Dialog } from 'vant'

import './permission' // permission control

Vue.use(Lazyload, {})
Vue.use(Dialog)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
